<template>
	<sf-data-table
		ref="dataTable"
		:pageUnit="pagingInfo.pageUnit"
		:totalSize="pagingInfo.totalSize"
		paging
		index
		:columns="columns"
		:rows="rows"
		:indexColumn="{ width: '40px', borderBottom: '1px solid #8da1b9 !important' }"
		:excel="isButton_(scrId, 'EX')"
		@changedPage="changedPage"
	>
	</sf-data-table>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../../store/helpers';

export default {
	props: { scrId: { type: String, default: '' } },
	computed: {
		...rootComputed,
		...serviceComputed,
		rows() {
			return this.resultList;
		},
		columns() {
			return this.getColumns_;
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		async changedPage({ currentPageVal, pageUnitVal, prePage, prePageUnit }) {
			if (!prePage || !prePageUnit) {
				//초기값 셋팅시 이미 searchBar에서 데이터를 조회했기 때문에 중복 조회 하지않도록 처리
				return;
			}
			this.setPagingInfo_({ key: 'currentPage', value: currentPageVal });
			this.setPagingInfo_({ key: 'pageUnit', value: pageUnitVal });
			this.$emit('Refresh');
		}
	}
};
</script>

<style></style>
